import { InitState } from "@gx1/gx-npm-lib";
import { createContext, Dispatch, ReactNode, SetStateAction, useState } from "react";
import { UserNotification } from "./app.types";

export interface MainNavAppV2ContextValue {
  isMobilePrimaryNavOpen: boolean;
  isNotificationsPanelOpen: boolean;
  initName: string;
  initState: InitState | "";
  notificationCount: number;
  notifications: UserNotification[];
  stateUpdateDate: string;
  setInitName: Dispatch<SetStateAction<string>>;
  setInitState: Dispatch<SetStateAction<InitState | "">>;
  setIsMobilePrimaryNavOpen: Dispatch<SetStateAction<boolean>>;
  setIsNotificationsPanelOpen: Dispatch<SetStateAction<boolean>>;
  setNotificationCount: Dispatch<SetStateAction<number>>;
  setNotifications: Dispatch<SetStateAction<UserNotification[]>>;
  setStateUpdateDate: Dispatch<SetStateAction<string>>;
}

export const MainNavAppV2Context = createContext<MainNavAppV2ContextValue>({} as MainNavAppV2ContextValue);

export const MainNavAppV2ContextProvider = (props: { children: ReactNode | ReactNode[] }) => {
  const [isMobilePrimaryNavOpen, setIsMobilePrimaryNavOpen] = useState(false);
  const [isNotificationsPanelOpen, setIsNotificationsPanelOpen] = useState(false);
  const [initName, setInitName] = useState<string>("");
  const [initState, setInitState] = useState<InitState | "">("");
  const [notificationCount, setNotificationCount] = useState(0);
  const [notifications, setNotifications] = useState<UserNotification[]>([]);
  const [stateUpdateDate, setStateUpdateDate] = useState("");

  const contextValue = {
    isMobilePrimaryNavOpen,
    isNotificationsPanelOpen,
    initName,
    initState,
    notificationCount,
    notifications,
    stateUpdateDate,
    setIsMobilePrimaryNavOpen,
    setIsNotificationsPanelOpen,
    setInitName,
    setInitState,
    setNotificationCount,
    setNotifications,
    setStateUpdateDate,
  };

  return <MainNavAppV2Context.Provider value={contextValue}>{props.children}</MainNavAppV2Context.Provider>;
};
